export const SET_CONNECTION = 'SET_CONNECTION'
